import React from "react";
import { useNavigate } from "react-router-dom";

const SupportPage = () => {
    const navigate = useNavigate();

    const pageWrapperStyle = {
        minHeight: '100vh',
        // backgroundImage: 'url("https://storage.googleapis.com/tmhimagebucket/FTMSTILLSQUASH.jpg")',
        backgroundImage: 'url("https://storage.googleapis.com/tmhimagebucket/lathedubplate.jpg")',

        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        position: 'relative'
    };

    const overlayStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: 0
    };

    const contentStyle = { position: 'relative', zIndex: 1 };

    return (
        <div style={pageWrapperStyle}>
            <div style={overlayStyle}></div>
            <div className="login-format" style={{ ...contentStyle, padding: "20px", textAlign: "center", cursor: "default" }}>
                <div style={{ width: "fit-content", margin: "0 auto", maxWidth: "600px" }}>
                    <h1 style={{ marginBottom: "30px" }}>Contact</h1>
                    <div style={{ textAlign: "center", marginBottom: "30px" }}>
                        <p style={{ marginBottom: "20px", fontSize: "16px", lineHeight: "1.6" }}>
                            Need help or got questions? Contact us at info@timehri.world or shoot a DM @timehrirecords
                        </p>
                    </div>
                    <button
                        onClick={() => navigate(-1)}
                        style={{
                            background: 'none',
                            border: '1px solid #009e4a',
                            color: '#009e4a',
                            padding: '12px 24px',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontFamily: 'CustomFont',
                            fontSize: '16px',
                            transition: 'all 0.2s'
                        }}
                        onMouseOver={(e) => {
                            e.target.style.background = '#009e4a';
                            e.target.style.color = 'black';
                        }}
                        onMouseOut={(e) => {
                            e.target.style.background = 'none';
                            e.target.style.color = '#009e4a';
                        }}
                    >
                        Back
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SupportPage;

